/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Personal / Commercial License.
 * See LICENSE_PERSONAL / LICENSE_COMMERCIAL in the project root for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UsersApi } from '../api/users.api';
import { UserData, User } from '../../../interfaces/common/users';

@Injectable()
export class UsersService extends UserData {

  constructor(private api: UsersApi) {
    super();
  }

  getAllUsersAdmin(): Observable<User[]> {
    return this.api.getAllUsersAdmin();
  }

  getCurrentUserAdmin(): Observable<User> {
    return this.api.getCurrentAdmin();
  }

  getAdmin(id: number): Observable<User> {
    return this.api.getAdmin(id);
  }

  createAdmin(user: any): Observable<User> {
    return this.api.addAdmin(user);
  }

  updateAdmin(user: any): Observable<User> {
    return this.api.updateAdmin(user);
  }

  updateCurrentAdmin(user: any): Observable<User> {
    return this.api.updateCurrentAdmin(user);
  }

  deleteAdmin(id: number): Observable<boolean> {
    return this.api.deleteAdmin(id);
  }

  /* Customer users from Client App */
  getAllUsersApp(): Observable<User[]> {
    return this.api.getAllUsersApp();
  }

  getCurrentUserApp(): Observable<User> {
    return this.api.getCurrentApp();
  }

  getApp(id: number): Observable<User> {
    return this.api.getApp(id);
  }

  createApp(user: any): Observable<User> {
    return this.api.addApp(user);
  }

  updateApp(user: any): Observable<User> {
    return this.api.updateApp(user);
  }

  updateCurrentApp(user: any): Observable<User> {
    return this.api.updateCurrentApp(user);
  }

  deleteApp(id: number): Observable<boolean> {
    return this.api.deleteApp(id);
  }
}
